module.exports = __webpack_public_path__ + "img/grupo-perfil.7353d1a7.svg";